import { render, staticRenderFns } from "./field-error.vue?vue&type=template&id=cb12f728&scoped=true"
import script from "./field-error.vue?vue&type=script&lang=js"
export * from "./field-error.vue?vue&type=script&lang=js"
import style0 from "./field-error.vue?vue&type=style&index=0&id=cb12f728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb12f728",
  null
  
)

export default component.exports